import { useState, useEffect } from 'react';

/**
 * Hook to manage demo modal state - shows once per view per session
 * Uses sessionStorage to track which views have shown the modal
 */
export function useDemoModal(currentView) {
  const [showDemoModal, setShowDemoModal] = useState(false);

  useEffect(() => {
    if (currentView) {
      // Check if modal has been shown for this view in this session
      const shownViews = JSON.parse(sessionStorage.getItem('demo-modal-views') || '[]');
      
      if (!shownViews.includes(currentView)) {
        // Show modal for this view
        setShowDemoModal(true);
        // Mark this view as shown
        const updatedViews = [...shownViews, currentView];
        sessionStorage.setItem('demo-modal-views', JSON.stringify(updatedViews));
      }
    }
  }, [currentView]);

  const closeDemoModal = () => {
    setShowDemoModal(false);
  };

  return {
    showDemoModal,
    closeDemoModal
  };
}
